module.exports = __webpack_public_path__ + "img/69.73ebd840.jpg";